import { IS_IE11 } from "../constants/validations";

export const getTodaysDate = () => {
    
    if(IS_IE11){
        return getMonthDayYearDate(new Date().toISOString().slice(0, 10), true);
    } else {
        return new Date().toISOString().slice(0, 10);
    }
}

export function getYMDfromMDYFormat(date) {
	let dateArray = [];
	if(date.includes("-")){
		dateArray = date.split("-");
	} else if(date.includes("/")){
		dateArray = date.split("/");
	}
	if(dateArray.length === 3){
		if(isCorrectMDYFormat(date)){
			let day = dateArray[1] < 10 ? "0" + Number(dateArray[1]) : Number(dateArray[1]);
			let month = dateArray[0] < 9 ? "0" + Number(dateArray[0]) : Number(dateArray[0]);
			return [
				Number(dateArray[2]),
				month,
				day
			].join("-");
		}
	}
	return null;
}

export function getMDYfromYMDFormat(date) {
	let dateArray = [];
	if(date.includes("-")){
		dateArray = date.split("-");
	} else if(date.includes("/")){
		dateArray = date.split("/");
	}
	if(dateArray.length === 3){
		if(isCorrectYMDFormat(date)){
			let day = dateArray[2] < 10 ? "0" + Number(dateArray[2]) : Number(dateArray[2]);
			let month = dateArray[1] < 9 ? "0" + Number(dateArray[1]) : Number(dateArray[1]);
			return [
				month,
				day,
				Number(dateArray[0])
			].join("/");
		}
	}
	return null;
}

export function getUTCDateFromString(date){
	var utcDate = date;
	const MIN_DATE_ARRAY_LENGTH = 3;
	const UTC_HOUR_MIDDAY = 12;
	let utcDay, utcMonth, utcYear, utcArray;

	if (utcDate) {
		utcArray = utcDate.split(" ")[0].split("-");
		if (utcArray.length >= MIN_DATE_ARRAY_LENGTH) {
			utcYear = utcArray[0];
			utcMonth = utcArray[1] - 1;
			utcDay = utcArray[2];
			utcDate = new Date(
				Date.UTC(utcYear, utcMonth, utcDay, UTC_HOUR_MIDDAY, 0, 0)
			);
		}
	}
	return utcDate;
}

export const getLocalStringDate = date => {
	if(isCorrectDateFormat(date)){
		let utcFormattedString = getYMDfromMDYFormat(date);
		let utcDate = getUTCDateFromString(utcFormattedString || date);
		let dateParts = utcDate.toString().split(" ");
		return `${dateParts[1]} ${Number(dateParts[2])}, ${dateParts[3]}`;
	} else {
		return date;
	}
}

export const getMonthDayYearDate = (date, isString) => {
	if(date){
		let dateObject = date;
		if(isString){
			dateObject = getUTCDateFromString(date);
		}
		let dateString = [
			Number(dateObject.getMonth() + 1),
			Number(dateObject.getDate()),
			dateObject.getFullYear()
		].join("/");
		if(dateString.includes(",")){
			return dateString.split(",")[0];
		}else{
			return dateString.split(" ")[0];
		}
	}
	else {
		return "";
	}
}

export const isCorrectMDYFormat = (dateString) => {
	let thisYear =  new Date().getFullYear();
	if(dateString.includes("/")){
		let stringParts = dateString.split("/");
		if(stringParts.length === 3){
			if(stringParts[0] >= 1 && stringParts[0] <= 12 && stringParts[0].length <= 2 &&
				stringParts[1] >= 1 && stringParts[1] <= 31 &&  stringParts[1].length <= 2 &&
				stringParts[2] >= thisYear-100 && stringParts[2] <= thisYear+100 &&  stringParts[2].length === 4
			){
				return true;
			}
		}
	}
	return false;
}

export const isCorrectYMDFormat = dateString => {
	let thisYear =  new Date().getFullYear();
	if(dateString.includes("-")){
		let stringParts = dateString.split("-");
		if(stringParts.length === 3){
			if(stringParts[1] >= 1 && stringParts[1] <= 12 && stringParts[1].length <= 2 &&
				stringParts[2] >= 1 && stringParts[2] <= 31 && stringParts[2].length <= 2 && 
				stringParts[0] >= thisYear-100 && stringParts[0] <= thisYear+100 && stringParts[0].length === 4
			){
				return true;
			}
		}
	}
	return false;
}

export const isCorrectDateFormat = (dateString) => {
	let isCorrect = false;
	let isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
	if(dateString.includes("-") && !isIE11){
		isCorrect = isCorrectYMDFormat(dateString);
	} else if (dateString.includes("/")) {
		isCorrect = isCorrectMDYFormat(dateString);
	}
	return isCorrect;
}

export const checkDateContinuity = dateString => {
	if(isCorrectDateFormat(dateString)){
		let dateToCheck = isCorrectMDYFormat(dateString) ? dateString : getMDYfromYMDFormat(dateString);
		let dateObjectToCheck = new Date(dateToCheck);
		
		if(dateObjectToCheck.getMonth() + 1 !== Number(dateToCheck.split("/")[0])){
			return false
		}
	}
	return true;
}

//2011-08-12T20:17:46
export const getDateTimeDisplay = dateTime => {
	if (dateTime) {
		if (dateTime.includes('T')) {
			let dateArray = dateTime.split('T');
			let dateValue = getMonthDayYearDate(dateArray[0], true);
			let timeArray = dateArray[1].split(":");
			timeArray[0] = Number(timeArray[0]);
			let period = "AM";
			if (timeArray[0] === 0)
			{
				timeArray[0] = 12;
			}
			else if (timeArray[0] >= 12)
			{
				if (timeArray[0] > 12)
				{
					timeArray[0] -= 12;
				}
				period = "PM";
			}
			let timeValue = `${timeArray[0]}:${timeArray[1].padStart(2, "0")} ${period}`;
			return `${dateValue} ${timeValue}`;
		} else {
			return getMonthDayYearDate(dateTime, true);
		}
	}
	return null;
}

// This only works if passed a Date object
/*function isDST(date) {
	if (date && Object.prototype.toString.call(date) === "[object Date]" && !isNaN(date))
	{
		let jan = new Date(date.getFullYear(), 0, 1).getTimezoneOffset();
		let jul = new Date(date.getFullYear(), 6, 1).getTimezoneOffset();
		return Math.max(jan, jul) !== date.getTimezoneOffset();
	}
	return false;
}*/

//Incoming string format: 2011-08-12T20:17:46
export const getDateTimeDisplayNew = dateTime => {
	if (dateTime) {
		if (dateTime.includes('T')) {
			// Convert the datetime string to a local date object, making sure to include the timezone
			// Since our datetime values are stored in American/Eastern timezone, we might need to change the 'Z' to:
			//'−05:00' for standard time (UTC-05:00)
			//'−04:00' for daylight saving time (UTC-04:00)
			// ^THIS^ will require us to know whether the date part falls under standard time or daylight savings time,
			//     and that's something we'd like to avoid if possible...
			let localDate = new Date(`${dateTime}Z`);
			let month = Number(localDate.getMonth()) + 1;
			let day = localDate.getDate();
			let year = localDate.getFullYear();
			let hour = Number(localDate.getHours());
			let minute = `${localDate.getMinutes()}`.padStart(2, "0");
			let period = hour >= 12 ? "PM" : "AM";
			if (hour === 0) {
				hour = 12;
			} else if (hour > 12) {
				hour -= 12;
			}
			// This should display the datetime in the correct format and account for the user's local timezone offset
			return `${month}/${day}/${year} ${hour}:${minute} ${period}`;
		} else {
			return getMonthDayYearDate(dateTime, true);
		}
	}
	return null;
}